import { render, staticRenderFns } from "./ModelsView.vue?vue&type=template&id=f1012626&scoped=true&"
import script from "./ModelsView.vue?vue&type=script&lang=js&"
export * from "./ModelsView.vue?vue&type=script&lang=js&"
import style0 from "./ModelsView.vue?vue&type=style&index=0&id=f1012626&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1012626",
  null
  
)

export default component.exports